<template>
    <nav class="navbar bg-white p-0 fixed-top shadow-sm" style="height: 88px;">
        <div style="height: 8px; width: 100%;" class="bg-primary"></div>
        <div class="container d-flex justify-content-start aling-items-center" style="height: 80px;">
            <router-link class="navbar-brand" :to="{ name: 'Client' }"><img :src="logo" height="46px"></router-link>
            <div style="height: 48px; width: 1px; background-color: #d8d8d8; margin-left: 16px; margin-right: 16px;"></div>
            <nav class="nav">
                <router-link class="nav-link" :class="{'active': $route.name == 'ClientLocator'}" :to="{ name: 'Client' }">
                    <span>CLIENTES</span>
                </router-link>
            </nav>
        </div>
    </nav>
</template>
<script>
import logo from '@/assets/logo.jpg'
export default {
  data () {
    return {
      logo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/Navbar.vue